module.exports = __webpack_public_path__ + "static/img/hero-war-logo.fd644408.png";